import { render, staticRenderFns } from "./remitDataTiktok.vue?vue&type=template&id=3d4e668c&scoped=true"
import script from "./remitDataTiktok.vue?vue&type=script&lang=js"
export * from "./remitDataTiktok.vue?vue&type=script&lang=js"
import style0 from "./remitDataTiktok.vue?vue&type=style&index=0&id=3d4e668c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4e668c",
  null
  
)

export default component.exports